/**
 * F31 (Wave 2B) — admin sport-skill-descriptors CMS API client.
 *
 * Endpoints (F31 plan §7.2):
 *   GET    /admin/sport-skill-descriptors        → list (all, grouped by sport)
 *   PUT    /admin/sport-skill-descriptors         → upsert
 *   DELETE /admin/sport-skill-descriptors/:id     → remove
 *
 * Permission gating server-side (sport_skill_descriptors:read for the page,
 * sport_skill_descriptors:write for upsert/delete). Component tests get the
 * in-memory mock via the vitest alias in `apps/admin/vitest.config.ts`.
 */
import type { SportSkillDescriptor, UpsertSportSkillDescriptorInput } from '@bravemove/types';
import type { SportName } from '@bravemove/design-tokens/icons';
import { adminFetch, buildQuery } from '../auth/apiClient';

interface DataEnvelope<T> {
  readonly data: T;
}

export interface ListDescriptorsOpts {
  readonly sport?: SportName;
}

export const adminSportSkillDescriptorsApi = {
  async list(opts: ListDescriptorsOpts = {}): Promise<SportSkillDescriptor[]> {
    const qs = buildQuery({ sport: opts.sport });
    const body = await adminFetch<DataEnvelope<readonly SportSkillDescriptor[]>>(
      `/admin/sport-skill-descriptors${qs}`,
    );
    return [...body.data];
  },

  async upsert(input: UpsertSportSkillDescriptorInput): Promise<SportSkillDescriptor> {
    const body = await adminFetch<DataEnvelope<SportSkillDescriptor>>(
      `/admin/sport-skill-descriptors`,
      { method: 'PUT', body: input as unknown as Record<string, unknown> },
    );
    return body.data;
  },

  async remove(id: string): Promise<void> {
    await adminFetch(`/admin/sport-skill-descriptors/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
  },
};
